module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      previewNode: _vm.isPreviewNode
    },
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "tag": "div",
      "enter-active-class": "animated bounceInLeft",
      "leave-active-class": "animated bounceOutLeft",
      "appear": ""
    }
  }, [_c('NavEditor', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPreviewNode),
      expression: "!isPreviewNode"
    }],
    staticClass: "naveditor",
    attrs: {
      "id": "naveditor"
    },
    on: {
      "isPreview": _vm.isPreview
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated bounceInLeft",
      "leave-active-class": "animated bounceOutLeft"
    }
  }, [_c('Topbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPreviewNode),
      expression: "!isPreviewNode"
    }],
    staticClass: "topbar",
    attrs: {
      "id": "topbar"
    }
  })], 1), _vm._v(" "), _c('main', [_c('transition', {
    attrs: {
      "enter-active-class": "animated bounceInLeft",
      "leave-active-class": "animated bounceOutLeft"
    }
  }, [_c('Editor', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPreviewNode),
      expression: "!isPreviewNode"
    }],
    staticClass: "editor",
    attrs: {
      "id": "editor"
    }
  })], 1), _vm._v(" "), _c('Preview', {
    staticClass: "preview",
    attrs: {
      "id": "preview"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "exitPreview"
    },
    on: {
      "click": _vm.isPreview
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true "
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-exit"
    }
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-791be110","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 200
// module chunks = 1